import * as bonusperiodActions from './bonusperiod.actions'
import * as formActions from './form.actions'
import * as userActions from './person.actions'
import * as toastererActions from './toasterer.actions'

import { default as formEpics } from './form.epic'
import { default as userEpics } from './person.epic'

export const sharedActions = {
  ...toastererActions,
  ...userActions,
  ...formActions,
  ...bonusperiodActions,
}

export const sharedEpics = [userEpics, formEpics]

export { getToasts } from './toasterer.reducer'
export { getUserHierarchy } from './person.reducer'
export {
  getActiveBonusPeriod,
  getBonusPeriods,
  getUserActiveBonusPeriod,
  getUserBonusPeriods,
} from './bonusperiod.reducer'

export { reducer, SharedState } from './shared.reducer'
export { StripHtmlPayload } from './form.actions'



// WEBPACK FOOTER //
// ./src/app/shared/store/index.ts